/**
 * Static admin credentials. Optional: set REACT_APP_VIZHACKS_ADMIN_EMAIL and
 * REACT_APP_VIZHACKS_ADMIN_PASSWORD to override (e.g. in .env.local or host env).
 * Client-side only — not suitable for high-security admin.
 */
export function getAdminCredentials() {
  const envEmail = (process.env.REACT_APP_VIZHACKS_ADMIN_EMAIL || "").trim();
  const envPassword = process.env.REACT_APP_VIZHACKS_ADMIN_PASSWORD || "";

  if (envEmail && envPassword) {
    return { email: envEmail, password: envPassword };
  }

  return {
    email: "anouar@vizhacks.com",
    password: "Tigtig25614541",
  };
}
